import { DateRange } from "./DateRange";

export class UserContextQuery {
    instance?: string;
    parentId?: string;
    address?: string;
    accountId?: string;
    userId?: string;
    dateRange?: DateRange;
    lastDate?: Date;
    lastId?: string;
}